import React, { useState } from 'react';
import { Button, ButtonGroup, Grid, makeStyles } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import AdminTopbar from './AdminTopbar';
import AdminFooter from './AdminFooter';
import PaperReviewList from './PaperReviewList';
import PaperReviewJudge from './PaperReviewJudge';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const PaperReviewPage = (props) => {
  const classes = useStyles();
  //  const { history } = props;
  //  const [data, setData] = useState();
  const [selectFilter, setSelectFilter] = useState('list');

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
  };

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={3} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <h1>Free Paper Review</h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'list' ? 'contained' : 'outlined'} onClick={() => handleFilter('list')}>
                  초록 심사
                </Button>
                <Button variant={selectFilter === 'judge' ? 'contained' : 'outlined'} onClick={() => handleFilter('judge')}>
                  심사위원 관리
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>{selectFilter === 'list' ? <PaperReviewList /> : <PaperReviewJudge />}</Grid>
      </Grid>
      <AdminFooter />
    </Grid>
  );
};

export default PaperReviewPage;
